import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

import Loader from '../../components/Loader/Loader';

import useDarkMode from '../../hooks/useDarkMode';

import { FlotiqLogo } from '../../images/shapes';

const testId = 'loading-page';

const LoaderPage = () => {
  const [darkMode] = useDarkMode();

  return (
    <div
      className={twMerge(
        'w-full h-screen flex flex-col justify-center items-center',
        darkMode && 'dark:bg-slate-900',
      )}
      {...getTestProps(testId, 'loader')}
    >
      <div className="inline-flex items-center justify-center">
        <FlotiqLogo className={'h-9 m-6'} />
      </div>

      <Loader type="spinner-grid" />
    </div>
  );
};

export default LoaderPage;
